<div [formGroup]="form">
  <div [formGroupName]="question.key">
    <input type="hidden" formControlName="value" [id]="question.key + '_value'" />
    <mat-form-field appearance="outline" [class]="question.settings && question.settings.size">
      <mat-icon class="search" matPrefix></mat-icon>
      <input
        matInput
        type="text"
        [placeholder]="question.settings && question.settings.placeholder"
        formControlName="input"
        [id]="question.key + '_input'"
        [matAutocomplete]="autoComplete"
        position="below"
        #autoCompleteInput="matAutocompleteTrigger"
      >

      <mat-autocomplete autoActiveFirstOption #autoComplete="matAutocomplete">
        <mat-option *ngIf="loading" value='' disabled>
          {{ (question.settings && question.settings.loading_text) ? question.settings.loading_text : 'Loading...' }}
        </mat-option>
        <mat-option *ngIf="loadingError" value='' disabled>
          {{ (question.settings && question.settings.error_text) ? question.settings.error_text : 'Error loading details' }}
        </mat-option>
        <mat-option *ngIf="!loading && !loadingError && searchText.length >= 3 && options.length === 0" value='' disabled>
          {{ (question.settings && question.settings.no_results_text) ? question.settings.no_results_text : 'Not able to find the details' }}
        </mat-option>
        <mat-option *ngIf="emptyQuery && question.settings && question.settings.empty_query_results" value='' disabled class="mat-option-empty-query-header">
          {{ question.settings.empty_query_results }}
        </mat-option>
        <mat-option *ngFor="let option of options; index as i;" [value]="option" (onSelectionChange)="onOptionSelect(option)" [class]="question.key + '-mat-option-' + i" [disabled]="option.is_disabled">
          <span [ngClass]="{'mat-option-disabled': option.is_disabled}">{{ option.label }}</span>
          <br *ngIf="option.is_disabled" />
          <div *ngIf="option.is_disabled" class="mat-option-unavailable flex">
            <div class="flex-shrink">
              <mat-icon class="info_outline material-icons-outlined margin-right-xxsmall"></mat-icon>
            </div>
            <div>{{ question.settings.disabled_option_tag }}</div>
          </div>
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
  </div>

  <div *ngIf="selectedOptions.length" class="selected-items margin-top-small">
    <span *ngFor="let option of selectedOptions">
      <button mat-flat-button (click)="removeOption(option)" type="button">{{ option.label }}<mat-icon class="clear" iconPositionEnd></mat-icon></button>
    </span>
  </div>

  <div class="raptor-question-error">
    <div *ngFor="let error of fieldErrors | keyvalue">
      <mat-error *ngIf="error.key === 'required'">This question is required</mat-error>
    </div>
  </div>
</div>
